module.exports = __webpack_public_path__ + "img/google-icon-multicolor.fe3bfcb5.svg";